export const leadTypeMap = {
    websites: "websites",
    companies: "companies",
} as const;

/**
 * Discriminator for the two row shapes a lead can take in DaaS results:
 * `companies` (company-keyed records) and `websites` (domain-keyed records).
 */
export type LeadsType = keyof typeof leadTypeMap;
